import React from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import * as defaultConst from '../../constants/default_constants'
import EmbededEntityInput from '../input/embedded_entity'
import OptionSelect from 'bstrap-react-mobx-admin/new_src/input/option_select'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import SelectInput from '../input/select'
import SelectWithSuggestions from '../input/select_suggested'
import TextField from 'react-mobx-admin/components/common/field/text'

const PPRollsConditions = ({ store, label, disabledEntityFromBatch, ...rest }) => {
  const getOpText = (tableName, itemID) => {
    const itemRec = store.options.has(tableName) && store.options.get(tableName).find(i => i.value === itemID)
    return itemRec && itemRec.text ? itemRec.text : itemID
  }

  const formPPRollsConditions = observer(({ state, record, updateFormField, errors }) => {
    const disabled = !store.hasRight(defaultConst.ENTNAMES.PPROLLS, 'w')
    const conditionTable = record.get('condition_table')

    const optSorted = store.options.has('flyprivate_all_tiers') &&
      store.options.get('flyprivate_all_tiers').filter(i => {
        const optText = getOpText('FlyPrivatePlatforms', i.platform)
        return optText[0] !== '['
      }).concat(store.options.get('flyprivate_all_tiers').filter(i => {
        const optText = getOpText('FlyPrivatePlatforms', i.platform)
        return optText[0] === '['
      }))
    store.options.set('flyprivate_all_tiers_sorted', optSorted)

    const catPlatform = conditionTable === 'categories' && !disabled && store.getCatPlatform(store, state, 'condition_key')
    const catPlatformFilter = conditionTable === 'categories' && !disabled ? store.getCatPlatformFilter(catPlatform) : undefined

    const getTier = conditionTable === 'tiers' && record.has('condition_key') &&
      record.get('condition_key') && parseInt(record.get('condition_key'))
    const getTierItem = conditionTable === 'tiers' && getTier && store.options.has('flyprivate_all_tiers_sorted') &&
      store.options.get('flyprivate_all_tiers_sorted').find(i => i.id === getTier)
    const getPlatform = conditionTable === 'tiers' && (
      state.platformFilter ||
      (getTierItem && getTierItem.platform) ||
      localStorage.getItem('platformFilter') ||
      (store.options.has('FlyPrivatePlatforms') && store.options.get('FlyPrivatePlatforms')[0].value)
    )
    const tierPlatformFilter = val => (!(val.platform === getPlatform))

    return (
      <div className='row'>
        <div className='col-sm-12 col-lg-6'>
          <SelectInput label={store.__('Condition')} attr={'condition_table'} record={record}
            optionsrecord={store.options}
            optionsattr={'pprollsConditions'}
            labelattr='label'
            valueattr='value'
            valueFilterFc={i => record.has('condition_table') &&
              defaultConst.PPROLLS_HIDDEN_OPTIONS.indexOf(record.get('condition_table')) > -1
              ? false
              : defaultConst.PPROLLS_HIDDEN_OPTIONS.indexOf(i.value) > -1 }
            onChange={updateFormField} errors={errors} disabled={disabled} />

          {conditionTable === 'platforms' && <SelectInput
            label={store.__('platforms')}
            attr={'condition_key'}
            record={record}
            labelattr='text'
            valueattr='value'
            onChange={updateFormField}
            optionsrecord={store.options}
            optionsattr={'FlyPrivatePlatforms'}
            errors={errors} disabled={disabled} />}

          {conditionTable === 'categories' && <OptionSelect
            attr='platformFilter' label={store.__('platform')} value={catPlatform}
            onChange={store.updateStorageField(store, state, 'condition_key')}
            options={store.options.get('FlyPrivatePlatforms')}
            disabled={disabled} labelattr='text' errors={errors} />}

          {conditionTable === 'categories' && <SelectInput
            attr={'condition_key'}
            label={store.__('categories')}
            record={record}
            labelattr='text'
            valueattr='value'
            onChange={updateFormField}
            optionsrecord={store.options}
            optionsattr='FlyprivateCategories'
            valueFilterFc={catPlatformFilter}
            errors={errors} disabled={disabled} />}

          {conditionTable === 'homepage' && <SelectInput label={store.__('homepage')} attr={'condition_key'} record={record}
            onChange={updateFormField} optionsrecord={store.options} optionsattr={'flyprivate_homepage_settings'}
            labelattr={i => (`${getOpText('FlyPrivatePlatforms', i.fp_platform_code)}
            | ${getOpText('FlyprivateCategories', i.fp_category_code)}
            | ${getOpText('FlyPrivateCategoryTypes', i.fp_category_type)}
            | ${i.valid_from} | ${i.valid_to} | ${i.id}`)} valueattr='id' errors={errors} />}

          {conditionTable === 'tiers' && <OptionSelect
            attr='platformFilter' label={store.__('platform')} value={getPlatform}
            onChange={store.updateStorageField(store, state, 'condition_key')}
            options={store.options.get('FlyPrivatePlatforms')}
            disabled={disabled} labelattr='text' errors={errors} />}

          {conditionTable === 'tiers' && <SelectInput label={store.__('tiers')} attr={'condition_key'} record={record}
            onChange={updateFormField} optionsrecord={store.options} optionsattr={'flyprivate_all_tiers_sorted'}
            valueFilterFc={tierPlatformFilter}
            labelattr={i => (`${getOpText('FlyPrivatePlatforms', i.platform)}
            | ${i.type_sale} | ${getOpText('PricingTiers', i.tier)}
            | ${i.id}`)} valueattr='id' errors={errors} />}

          {conditionTable === 'pricings' && <SelectInput label={store.__('pricings')} attr={'condition_key'} record={record}
            onChange={updateFormField} optionsrecord={store.options} optionsattr={'flyprivate_all_pricings'}
            valueFilterFc={i => i.valid_to === null || i.valid_to === '' || moment(i.valid_to).isSameOrBefore(moment())}
            labelattr={i => (`tier: ${i.flyprivate_platform_tier_id} | ${i.currency_cd} | ${i.quality_sd_price} | ${i.regions} | ${i.valid_from} | ${i.valid_to} | ${i.id}`)} valueattr='id' errors={errors} />}

          {conditionTable === 'film' && <SelectWithSuggestions label={store.__('film')}
            attr={'condition_key'} record={record}
            onChange={updateFormField} labelattr='title' valueattr='id'
            optionsrecord={store.options} optionsattr={'films'} errors={errors} />
          }
        </div>
      </div>
    )
  })

  const attr = 'pprolls_conditions'
  return (
    <EmbededEntityInput {...rest}
      disabled={!!disabledEntityFromBatch}
      attr={attr}
      store={store}
      items={store.cv.record.get(attr)}
      label={label || store.__('Conditions')}
      add_title={store.__('Add item')}
      edit_title={store.__('Edit item')}
      errors={store.cv.errors}
      fields={[
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => (<OptionsField
          attr={attr}
          val={row[attr]}
          options={store.options.get('pprollsConditions')}
          labelattr='label'
          valueattr='value' />),
        (attr, row) => {
          const conditionTable = row && row.condition_table
          const component = ({ text }) => {
            if (conditionTable === 'platforms') {
              const i = store.options.has('FlyPrivatePlatforms') && store.options.get('FlyPrivatePlatforms').find(i => i.value === text)
              return i ? `${i.text}` : text
            } else if (conditionTable === 'categories') {
              const i = store.options.has('FlyprivateCategories') && store.options.get('FlyprivateCategories').find(i => i.value === text)
              return i ? `${i.text}` : text
            } else if (conditionTable === 'homepage') {
              const i = store.options.has('flyprivate_homepage_settings') && store.options.get('flyprivate_homepage_settings').find(i => i.id === parseInt(text))
              return i ? `${getOpText('FlyPrivatePlatforms', i.fp_platform_code)}
              | ${getOpText('FlyprivateCategories', i.fp_category_code)}
              | ${getOpText('FlyPrivateCategoryTypes', i.fp_category_type)}
              | ${i.valid_from} | ${i.valid_to} | ${i.id}` : text
            } else if (conditionTable === 'tiers') {
              const i = store.options.has('flyprivate_all_tiers') && store.options.get('flyprivate_all_tiers').find(i => i.id === parseInt(text))
              return i ? `${getOpText('FlyPrivatePlatforms', i.platform)} | ${getOpText('PricingTiers', i.tier)} | ${i.type_sale} | ${i.id}` : text
            } else if (conditionTable === 'pricings') {
              const i = store.options.has('flyprivate_all_pricings') && store.options.get('flyprivate_all_pricings').find(i => i.id === parseInt(text))
              const ii = i && store.options.has('flyprivate_all_tiers') && store.options.get('flyprivate_all_tiers').find(j => j.id === parseInt(i.flyprivate_platform_tier_id))
              return i ? `tier: ${ii.id} - ${ii.type_sale} - ${getOpText('PricingTiers', ii.tier)} - ${ii.type_sale} | ${i.currency_cd} | ${i.quality_sd_price} | ${i.regions} | ${i.valid_from} | ${i.valid_to} | ${i.id}` : text
            } else if (conditionTable === 'film') {
              const i = store.options.has('films') && store.options.get('films').find(i => i.id === parseInt(text))
              return i ? `${i.title}` : text
            } else {
              return text
            }
          }
          return <TextField attr={attr} val={row[attr]} Component={component} />
        }
      ]}
      rowId={(row) => null}
      EditForm={formPPRollsConditions}
    />
  )
}

PPRollsConditions.propTypes = {
  store: PropTypes.object.isRequired
}

export default observer(PPRollsConditions)
